module.exports = __webpack_public_path__ + "img/005岳晋琛.ed77c2dd.jpg";